import { render } from "./PublicStepTwo.vue?vue&type=template&id=1181089c&scoped=true"
import script from "./PublicStepTwo.vue?vue&type=script&lang=js"
export * from "./PublicStepTwo.vue?vue&type=script&lang=js"

import "./PublicStepTwo.vue?vue&type=style&index=0&id=1181089c&scoped=true&lang=css"

import exportComponent from "/Users/diekstra/PhpstormProjects/rbs-vlb-reservations/rvr-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1181089c"]])

export default __exports__